import styled from 'styled-components';
import { colors, fontWeight } from '@grnhse/seedling/lib/azalea/constants';

const EmptyState = styled.div`
  color: ${colors.mediumGrey};
  font-size: 14px;
  ${/* @ts-expect-error */ ''}
  font-style: ${(props) => (props.emphasize ? 'italic' : 'normal')};
  font-weight: ${fontWeight.normal};
  margin-top: 16px;
`;

export default EmptyState;
